import React from "react";
import { useFormContext, useController } from "react-hook-form";

const PrintSSField = ({ label, source, type = 'text', placeholder, labelClass = "lable_title", additionalInputClass = "" }) => {
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    name: source,
    control,
  });
  function maskNumber(number) {
    let numStr = number.toString();
    let digitCount = 0;
    let maskedStr = '';

    for (let char of numStr) {
      if (char === '-') {
        maskedStr += '-'; // Keep hyphen as is
      } else {
        if (digitCount < 5) {
          maskedStr += '*'; // Mask first 6 digits
        } else {
          maskedStr += char; // Keep remaining digits visible
        }
        digitCount++;
      }
    }

    return maskedStr;
  }
  return (

    <div className="emp-inputs form-label">
      {<label className={`${labelClass} ${error && "text-danger"}`} htmlFor="inputs">{"SSN Number"}</label>}
      <input
        type={type ? type : "text"}
        placeholder={placeholder || `${label}`}
        className={`form-control cus-input-control ${additionalInputClass}`}
        {...field}
        value={field.value? maskNumber(field.value): ""}
        id={source}
        autoComplete={"nope"} // Added to prevent browser cache email issue.
      />
      <div
        className="invalid-feedback"
        style={{ display: "block", fontSize: "70%" }}
      >
      </div>
    </div>
  );
};

export default PrintSSField;
